var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.tableData.length ? _c("div", {
    staticClass: "data-authority"
  }, [_vm.tableData.length && _vm.tableData.length > 0 ? _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      columns: _vm.columns,
      "data-source": _vm.tableData,
      bordered: "",
      pagination: false,
      rowKey: "arrId",
      defaultExpandAllRows: true
    },
    scopedSlots: _vm._u([{
      key: "structureName",
      fn: function (text, record) {
        return [_c("a-tooltip", {
          attrs: {
            placement: "topLeft",
            title: !text || record.authorityTypeValue === 1 || record.authorityTypeValue === 2 ? "—" : text
          }
        }, [_vm._v(" " + _vm._s(!text || record.authorityTypeValue === 1 || record.authorityTypeValue === 2 ? "—" : text))])];
      }
    }, {
      key: "agencyName",
      fn: function (text, record) {
        return [_c("a-tooltip", {
          attrs: {
            placement: "topLeft",
            title: !text || record.authorityTypeValue === 1 || record.authorityTypeValue === 2 ? "—" : text
          }
        }, [_vm._v(" " + _vm._s(!text || record.authorityTypeValue === 1 || record.authorityTypeValue === 2 ? "—" : text))])];
      }
    }, {
      key: "operation",
      fn: function (text, record, index) {
        return [_c("a-button", {
          staticClass: "marginR15",
          attrs: {
            disabled: record.authorityTypeValue === 1 || record.authorityTypeValue === 2 || _vm.isOperate(record),
            type: record.authorityTypeValue === 1 || record.authorityTypeValue === 2 || _vm.isOperate(record) ? "danger" : "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.onChangeAuthorityRadio(record, "edit");
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]), _c("a-button", {
          attrs: {
            disabled: record.authorityTypeValue === 1 || record.authorityTypeValue === 2 || _vm.isOperate(record),
            type: "danger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.onDelete(record, index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))])];
      }
    }], null, false, 3364113710)
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0) : _vm._e(), _c("a-button", {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onConfirmAuthority
    }
  }, [_vm._v(_vm._s(_vm.$t("确认")))]), _c("data-authority-department", {
    ref: "authorityDepartmentRef",
    attrs: {
      authorityType: _vm.authorityType
    },
    on: {
      onChangeSave: _vm.updateTemporaryTableData
    }
  })], 1) : _c("div", {
    staticClass: "no-data-show"
  }, [_vm._v(" " + _vm._s(_vm.$t("请先完成功能权限配置")) + "   "), _c("svg-icon", {
    attrs: {
      icon: "warn",
      size: 20
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };